import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventShellComponent } from './pages/event-shell/event-shell.component';


const routes: Routes = [
  {
    path: 'event/:token',
    component: EventShellComponent
  },
  {
    path: ':token',
    component: EventShellComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
